export function validateCuts(sheetSize, cuts) {
  let currentPosition = { x: 0, y: 0 };
  let maxY = 0;

  for (let cut of cuts) {
    if (currentPosition.x + cut.width > sheetSize.width) {
      currentPosition.x = 0;
      currentPosition.y = maxY;
    }

    if (currentPosition.y + cut.height > sheetSize.height) {
      return false; // Деталь выходит за пределы листа
    }

    currentPosition.x += cut.width;
    if (currentPosition.y + cut.height > maxY) {
      maxY = currentPosition.y + cut.height;
    }
  }

  return true; // Все детали уместились на листе
}

export function distributeCuts(sheetSize, cuts) {
  let currentPosition = { x: 10, y: 10 };
  let maxY = 0;
  const placedCuts = [];
  const unplacedCuts = [];

  cuts.forEach((cut) => {
    if (currentPosition.x + cut.width > sheetSize.width) {
      currentPosition.x = 10;
      currentPosition.y = maxY + 10;
    }

    if (currentPosition.y + cut.height > sheetSize.height) {
      unplacedCuts.push(cut);
    } else {
      placedCuts.push({ ...cut, x: currentPosition.x, y: currentPosition.y });
      currentPosition.x += cut.width + 10;
      if (currentPosition.y + cut.height > maxY) {
        maxY = currentPosition.y + cut.height;
      }
    }
  });

  return { placedCuts, unplacedCuts };
}

export function generateSKU(id) {
  const numericId = id.replace(/\D/g, "").padStart(6, "0"); // Extracts digits, ensures at least 6 digits
  const randomNum = Math.floor(1000 + Math.random() * 9000); // 4-digit random number

  return `${numericId}-${randomNum}`;
}
